
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { ExternalTransactionKind } from '@/common/bot/enum/ExternalTransactionType';
import SingleSelect from '@/components/SingleSelect.vue';

interface TransactionStatusOption {
  value: ExternalTransactionKind;
  label: string;
}

@Component({
  components: {
    SingleSelect
  }
})
export default class ListControls extends Vue {
  @PropSync('currentPage', { type: Number, required: true }) sCurrentPage!: number;
  @PropSync('transactionStatus', { required: true }) sTransactionStatus!: ExternalTransactionKind;
  @Prop(String) readonly placeholder!: string;
  @Prop({ required: true }) readonly totalPages!: number;
  @Prop({ required: true }) readonly transactionStatuses!: TransactionStatusOption[];

  get isPrevDisabled() {
    return this.sCurrentPage === 1;
  }

  get isNextDisabled() {
    return this.sCurrentPage === this.totalPages;
  }

  get statuses() {
    const emptyOption = {
      value: '',
      label: this.$t('page.issue.status')
    };
    return [emptyOption, ...this.transactionStatuses];
  }

  get pageOptions() {
    return Array.from({ length: this.totalPages }, (_, index) => ({
      value: index + 1,
      label: String(index + 1)
    }));
  }

  handleTransactionTypeChange(value: string | number) {
    this.sTransactionStatus = value as ExternalTransactionKind;
  }

  handlePageChange(value: string | number) {
    this.sCurrentPage = Number(value);
  }

  handlePrevPage() {
    if (this.isPrevDisabled) return;
    this.sCurrentPage = this.sCurrentPage - 1;
  }

  handleNextPage() {
    if (this.isNextDisabled) return;
    this.sCurrentPage = this.sCurrentPage + 1;
  }
}
